import { PdfBorderStyle, PdfFontFamily } from './PdfComponent';

const mmToPx = (mm: number) => (mm * 96) / 25.4;
const pxToMm = (px: number) => (px * 25.4) / 96;
// ISO 216 sizes in mm (portrait)
const A4_WIDTH_MM = 210;
const A4_HEIGHT_MM = 297;
const A3_WIDTH_MM = 297;
const A3_HEIGHT_MM = 420;
const GRID_MM = 5;
const GRID_PX = mmToPx(GRID_MM);
// factor to convert font size in points to line height in mm.
const LINE_HEIGHT_FACTOR = 1.2;

const mmToPt = (mm: number) => (mm * 72) / 25.4;
const ptToMm = (pt: number) => (pt * 25.4) / 72;

const PAGE_SIZES = {
  A3: {
    portrait: { width: A3_WIDTH_MM, height: A3_HEIGHT_MM },
    landscape: { width: A3_HEIGHT_MM, height: A3_WIDTH_MM },
  },
  A4: {
    portrait: { width: A4_WIDTH_MM, height: A4_HEIGHT_MM },
    landscape: { width: A4_HEIGHT_MM, height: A4_WIDTH_MM },
  },
} as const;

export const pdfFontFamilyToCss = (family: PdfFontFamily): { fontFamily: string; fontWeight?: number | string } => {
  switch (family) {
    case PdfFontFamily.helvetica:
      return { fontFamily: 'Helvetica, Arial, sans-serif' };
    case PdfFontFamily.helveticaBold:
      return { fontFamily: 'Helvetica, Arial, sans-serif', fontWeight: 600 };
    case PdfFontFamily.timesRoman:
      return { fontFamily: '"Times New Roman", Times, serif' };
    case PdfFontFamily.timesBold:
      return { fontFamily: '"Times New Roman", Times, serif', fontWeight: 600 };
    case PdfFontFamily.courier:
      return { fontFamily: '"Courier New", Courier, monospace' };
    case PdfFontFamily.courierBold:
      return { fontFamily: '"Courier New", Courier, monospace', fontWeight: 600 };
    case PdfFontFamily.symbol:
      return { fontFamily: 'Symbol, serif' };
    default:
      return { fontFamily: 'Helvetica, Arial, sans-serif' };
  }
};

export const pdfBorderStyleToCss = (style: PdfBorderStyle): string => {
  switch (style) {
    case PdfBorderStyle.solid:
      return 'solid';
    case PdfBorderStyle.dashed:
      return 'dashed';
    case PdfBorderStyle.dotted:
      return 'dotted';
  }
};

export const PdfTemplateUtil = {
  mmToPx,
  pxToMm,
  // roundMm,
  A4_WIDTH_MM,
  A4_HEIGHT_MM,
  A3_WIDTH_MM,
  A3_HEIGHT_MM,
  GRID_MM,
  GRID_PX,
  mmToPt,
  ptToMm,
  PAGE_SIZES,
  LINE_HEIGHT_FACTOR,
};
